/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Ravindra Pandit Ahire",
  title: "Hi all, I'm Ravindra",
  subTitle: emoji(
    "A passionate Cybersecurity & Hardware Specialist | AI & Data Science Student 🚀 having experience in Linux systems, intrusion detection, network security, and building security tools."
  ),
  resumeLink: require("./resources/resume/CS_HackRore_Resume.pdf"), // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/HackRore",
  linkedin: "https://linkedin.com/in/ravindra-ahire-256b61326",
  gmail: "HackRore@gmail.com",
  youtube: "https://youtube.com/@CyberTechX_ravin",
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CYBERSECURITY SPECIALIST & HARDWARE EXPERT WHO LOVES BUILDING SECURITY TOOLS",
  skills: [
    emoji(
      "🛡️ Cybersecurity & Penetration Testing - Linux, Kali Linux, Snort IDS, Wireshark, Metasploit"
    ),
    emoji("💻 Hardware Diagnostics & Repair - Laptop troubleshooting, system assembly, IT support"),
    emoji("📱 Android Development - Java, XML, modern UI design")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "linux",
      fontAwesomeClassname: "fab fa-linux"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sql",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "git",
      fontAwesomeClassname: "fab fa-git-alt"
    },
    {
      skillName: "android",
      fontAwesomeClassname: "fab fa-android"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Savitribai Phule Pune University (SPPU)",
      logo: require("./assets/images/sppu.webp"),
      subHeader: "Bachelor of Engineering (B.E.) – Artificial Intelligence & Data Science",
      duration: "2023 – 2026",
      desc: "Pursuing B.E. in AI & Data Science",
      descBullets: []
    },
    {
      schoolName: "MSBTE",
      logo: require("./assets/images/msbte.webp"),
      subHeader: "Diploma in Computer Engineering",
      duration: "Completed",
      desc: "Completed with 84.23%",
      descBullets: ["Diploma in Computer Engineering with distinction"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Cybersecurity", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Hardware & IT Support",
      progressPercentage: "85%"
    },
    {
      Stack: "Programming",
      progressPercentage: "75%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Laptop Technician",
      company: "Hynet Technologies",
      companylogo: require("./assets/images/hynet-logo-transperent-.png"),
      date: "2025 – Present",
      desc: "Diagnosing and repairing laptops and desktops, OS installation and configuration, hardware troubleshooting, customer technical support, and system performance optimization."
    },
    {
      role: "Cybersecurity Intern",
      company: "Prodigy InfoTech",
      companylogo: require("./assets/images/prodigy infotech logo.svg"),
      date: "Internship Period",
      desc: "Worked on security-based tasks including vulnerability assessment, log monitoring, and implementing basic intrusion detection setups."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME SECURITY PROJECTS AND APPLICATIONS I HAVE BUILT",
  projects: [
    {
      image: require("./assets/images/snort.png"),
      projectName: "Intrusion Detection System with Snort",
      projectDesc: "Configured and deployed Snort IDS on Linux for real-time network traffic monitoring and attack detection.",
      footerLink: [
        {
          name: "View Project",
          url: "https://github.com/HackRore"
        }
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Image Encryption Tool (Python)",
      projectDesc: "Developed an encryption tool to secure image files using cryptographic techniques.",
      footerLink: [
        {
          name: "View Project",
          url: "https://github.com/HackRore"
        }
      ]
    },
    {
      image: require("./assets/images/network packet.webp"),
      projectName: "Packet Sniffer & Analyzer",
      projectDesc: "Built a Python-based network packet capturing and analysis tool.",
      footerLink: [
        {
          name: "View Project",
          url: "https://github.com/HackRore"
        }
      ]
    },
    {
      image: require("./assets/images/Calculator_(iOS_26)_app_icon.png"),
      projectName: "Android Calculator App",
      projectDesc: "Designed a modern gradient UI calculator using XML and Java with responsive layout.",
      footerLink: [
        {
          name: "View Project",
          url: "https://github.com/HackRore"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "My Certifications, Training, and Achievements",

  achievementsCards: [
    {
      title: "Infosys Cyber Operations",
      subtitle:
        "Infosys Certified Cyber Operations Professional",
      image: require("./resources/certificates/infosysy ravindra cyber operations certificate_page-0001.jpg"),
      imageAlt: "Infosys Cyber Operations Certificate",
      footerLink: [
        {
          name: "Certificate",
          url: "https://drive.google.com/viewerng/viewer?embedded=true&url=https://raw.githubusercontent.com/HackRore/developerFolio/master/src/resources/certificates/infosysy%20ravindra%20cyber%20operations%20certificate_page-0001.jpg"
        }
      ]
    },
    {
      title: "USDC Hardware Technician",
      subtitle:
        "Government Certified IT Hardware Technician",
      image: require("./resources/certificates/USDC gov certified in Hardware Technician.pdf"),
      imageAlt: "USDC Hardware Certificate",
      footerLink: [
        {
          name: "Certificate",
          url: ""
        }
      ]
    },
    {
      title: "IT Hardware Service Technician",
      subtitle:
        "Certified IT Hardware Service Technician",
      image: require("./resources/certificates/Service Technician IT Hardware certificate.pdf"),
      imageAlt: "Service Technician Certificate",
      footerLink: [
        {
          name: "Certificate",
          url: ""
        }
      ]
    },
    {
      title: "Wipro Pregrad Cybersecurity",
      subtitle:
        "Wipro Pregrad Program - Cybersecurity Training",
      image: require("./assets/images/wipro pregrad.jpg"),
      imageAlt: "Wipro Cybersecurity Training",
      footerLink: [
        {
          name: "Certificate",
          url: ""
        }
      ]
    },
    {
      title: "Kali Linux Certification",
      subtitle:
        "Kali Linux Tutorial and Certification",
      image: require("./resources/certificates/Kali Linux.png"),
      imageAlt: "Kali Linux Certificate",
      footerLink: [
        {
          name: "Certificate",
          url: ""
        }
      ]
    },
    {
      title: "Linux Tutorial",
      subtitle:
        "Linux Tutorial Completion Certificate",
      image: require("./resources/certificates/Linux_Tutorial.png"),
      imageAlt: "Linux Tutorial Certificate",
      footerLink: [
        {
          name: "Certificate",
          url: ""
        }
      ]
    },
    {
      title: "Cyber Security National Seminar",
      subtitle:
        "National Seminar on Cyber Security",
      image: require("./resources/certificates/Cyber Security National Seminar.png"),
      imageAlt: "Cyber Security Seminar",
      footerLink: [
        {
          name: "Certificate",
          url: ""
        }
      ]
    },
    {
      title: "AI & IOT Certification",
      subtitle:
        "Artificial Intelligence & IOT Training",
      image: require("./resources/certificates/AI_&_IOT.png"),
      imageAlt: "AI & IOT Certificate",
      footerLink: [
        {
          name: "Certificate",
          url: ""
        }
      ]
    },
    {
      title: "AI and Python",
      subtitle:
        "AI and Python Programming Certification",
      image: require("./resources/certificates/AI and Python.png"),
      imageAlt: "AI and Python Certificate",
      footerLink: [
        {
          name: "Certificate",
          url: ""
        }
      ]
    },
    {
      title: "Python for Data Science",
      subtitle:
        "Python for Data Science Certification",
      image: require("./resources/certificates/python_for_Data_Science.png"),
      imageAlt: "Python for Data Science Certificate",
      footerLink: [
        {
          name: "Certificate",
          url: ""
        }
      ]
    },
    {
      title: "Android Application Development",
      subtitle:
        "Android App Development Training",
      image: require("./resources/certificates/Android_Application_Development.png"),
      imageAlt: "Android Development Certificate",
      footerLink: [
        {
          name: "Certificate",
          url: ""
        }
      ]
    },
    {
      title: "Flutter for Beginners",
      subtitle:
        "Flutter Mobile App Development Course",
      image: require("./resources/certificates/Flutter for Beginners.png"),
      imageAlt: "Flutter Certificate",
      footerLink: [
        {
          name: "Certificate",
          url: ""
        }
      ]
    },
    {
      title: "Basic Java",
      subtitle:
        "Basic Java Programming Certification",
      image: require("./resources/certificates/Basic_Java.png"),
      imageAlt: "Basic Java Certificate",
      footerLink: [
        {
          name: "Certificate",
          url: ""
        }
      ]
    },
    {
      title: "Java DSA Beginners",
      subtitle:
        "Java Data Structures & Algorithms",
      image: require("./resources/certificates/Java_DSA_Beginers.png"),
      imageAlt: "Java DSA Beginners Certificate",
      footerLink: [
        {
          name: "Certificate",
          url: ""
        }
      ]
    },
    {
      title: "Java DSA Intermediate",
      subtitle:
        "Java Data Structures & Algorithms - Intermediate",
      image: require("./resources/certificates/Java_DSA_Intermediate.png"),
      imageAlt: "Java DSA Intermediate Certificate",
      footerLink: [
        {
          name: "Certificate",
          url: ""
        }
      ]
    },
    {
      title: "IOT Certification",
      subtitle:
        "Internet of Things (IOT) Training",
      image: require("./resources/certificates/IOT.png"),
      imageAlt: "IOT Certificate",
      footerLink: [
        {
          name: "Certificate",
          url: ""
        }
      ]
    },
    {
      title: "Intro to Cyber Security",
      subtitle:
        "Introduction to Cyber Security Course",
      image: require("./resources/certificates/Intro Cyber Security.png"),
      imageAlt: "Intro Cyber Security Certificate",
      footerLink: [
        {
          name: "Certificate",
          url: ""
        }
      ]
    },
    {
      title: "Intro to Digital Marketing",
      subtitle:
        "Introduction to Digital Marketing",
      image: require("./resources/certificates/Intro_Digital_Marketing.png"),
      imageAlt: "Digital Marketing Certificate",
      footerLink: [
        {
          name: "Certificate",
          url: ""
        }
      ]
    },
    {
      title: "Intro to Git Copilot",
      subtitle:
        "Introduction to GitHub Copilot",
      image: require("./resources/certificates/Intro_Git_Copilot.png"),
      imageAlt: "Git Copilot Certificate",
      footerLink: [
        {
          name: "Certificate",
          url: ""
        }
      ]
    },
    {
      title: "ChatGPT for Coders",
      subtitle:
        "ChatGPT for Programmers Certification",
      image: require("./resources/certificates/ChatGPT for Coders.png"),
      imageAlt: "ChatGPT Certificate",
      footerLink: [
        {
          name: "Certificate",
          url: ""
        }
      ]
    },
    {
      title: "Freedom with AI Masterclass",
      subtitle:
        "AI Masterclass Session Certificate",
      image: require("./resources/certificates/freedom with ai masterclass session certificate.pdf"),
      imageAlt: "AI Masterclass Certificate",
      footerLink: [
        {
          name: "Certificate",
          url: ""
        }
      ]
    },
    {
      title: "Pregrad Training Letter",
      subtitle:
        "Wipro Pregrad Training Letter",
      image: require("./resources/certificates/Pregrad Training Letter - Ravindra .pdf"),
      imageAlt: "Training Letter",
      footerLink: [
        {
          name: "View",
          url: ""
        }
      ]
    },
    {
      title: "Prodigy Infotech Offer Letter",
      subtitle:
        "Internship Offer Letter from Prodigy InfoTech",
      image: require("./resources/certificates/Prodigy Infotech Offer Letter.pdf"),
      imageAlt: "Offer Letter",
      footerLink: [
        {
          name: "View",
          url: ""
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Security and Technology, I share my knowledge through YouTube",
  displayMediumBlogs: "false", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://youtube.com/@CyberTechX_ravin",
      title: "CyberTechX YouTube Channel",
      description:
        "Technical content on cybersecurity, hardware tutorials, and tech reviews"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY KNOWLEDGE AND CONNECT WITH THE COMMUNITY 😅"
  ),
  talks: [],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT TECHNOLOGY AND SECURITY",
  podcast: [],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+91-9322026193",
  email_address: "HackRore@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
